import Page from 'modules/BiomeHowItWorks'

export default Page

